import React from 'react';

const MultifactorSVG = () =>
  <svg height="54px" width="53px" version="1.1" viewBox="0 0 53 54">
    <g fill="none" stroke="none" strokeLinecap="square" strokeWidth="1">
      <g transform="translate(-195.000000, -478.000000)">
        <g transform="translate(157.000000, 115.000000)">
          <g transform="translate(-1.000000, 107.000000)">
            <g transform="translate(39.000000, 29.000000)">
              <g transform="translate(0.000000, 218.853047)">
                <g transform="translate(0.000000, 9.000000)">
                  <path
                    d="M52.5091,26.2545 C52.5091,11.7545 40.7551,0.0005 26.2551,0.0005 C11.7551,0.0005 0.0001,11.7545 0.0001,26.2545 C0.0001,40.7545 11.7551,52.5095 26.2551,52.5095 C40.7551,52.5095 52.5091,40.7545 52.5091,26.2545"
                    fill="#ECECEC"
                  />
                  <g transform="translate(17.000000, 12.000000)">
                    <path
                      d="M15.7972,28.2545 L2.7122,28.2545 C1.6612,28.2545 0.8012,27.3955 0.8012,26.3445 L0.8012,2.1645 C0.8012,1.1135 1.6612,0.2545 2.7122,0.2545 L15.7972,0.2545 C16.8482,0.2545 17.7072,1.1135 17.7072,2.1645 L17.7072,26.3445 C17.7072,27.3955 16.8482,28.2545 15.7972,28.2545"
                      fill="#FFFFFF"
                    />
                    <path
                      d="M15.7972,28.2545 L2.7122,28.2545 C1.6612,28.2545 0.8012,27.3955 0.8012,26.3445 L0.8012,2.1645 C0.8012,1.1135 1.6612,0.2545 2.7122,0.2545 L15.7972,0.2545 C16.8482,0.2545 17.7072,1.1135 17.7072,2.1645 L17.7072,26.3445 C17.7072,27.3955 16.8482,28.2545 15.7972,28.2545 Z"
                      stroke="#222228"
                      strokeWidth="1.5"
                    />
                    <path d="M17.7074,20.6343 L0.8014,20.6343" stroke="#222228" strokeWidth="1.5" />
                    <path d="M0.8016,4.6754 L17.7076,4.6754" stroke="#222228" strokeWidth="1.5" />
                    <path
                      d="M10.828,24.4674 C10.828,25.3364 10.123,26.0404 9.255,26.0404 C8.386,26.0404 7.682,25.3364 7.682,24.4674 C7.682,23.5984 8.386,22.8944 9.255,22.8944 C10.123,22.8944 10.828,23.5984 10.828,24.4674"
                      fill="#231F1F"
                    />
                    <polyline
                      points="13.4881 9.2833 8.0741 14.6963 5.9671 12.5893"
                      stroke="#EC5424"
                      strokeWidth="1.5"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>;

export default MultifactorSVG;



// WEBPACK FOOTER //
// ./src/svg/MultifactorSVG.js